export interface VideoItem {
  id: string;
  title: string;
  category: string;
  thumbnail: string;
  duration: string;
  year: number;
  rating: number;
  description: string;
  region: string;
  views: string;
  isNew: boolean;
  isHot: boolean;
  tags: string[];
}

export const videos: VideoItem[] = [
  {
    id: 'v001',
    title: '千与千寻',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Spirited%20Away%20inspired%20Japanese%20anime%20film%20aesthetic%2C%20warm%20golden%20and%20cream%20tones%2C%20dreamy%20fantasy%20atmosphere%2C%20soft%20lighting%2C%20elegant%20minimalist%20composition%2C%20studio%20Ghibli%20style%20visual%2C%20clean%20background&width=800&height=450&seq=video-thumb-001&orientation=landscape',
    duration: '125分钟',
    year: 2001,
    rating: 9.4,
    description: '宫崎骏代表作，讲述少女千寻在神灵世界的奇幻冒险，获得奥斯卡最佳动画长片。',
    region: '日本',
    views: '1280万',
    isNew: false,
    isHot: true,
    tags: ['动画', '奇幻', '经典'],
  },
  {
    id: 'v002',
    title: '寄生虫',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Parasite%20Korean%20film%20aesthetic%2C%20modern%20architectural%20house%2C%20warm%20dramatic%20lighting%2C%20cream%20and%20beige%20tones%2C%20elegant%20cinematic%20composition%2C%20minimalist%20design%2C%20Oscar%20winning%20film%20style&width=800&height=450&seq=video-thumb-002&orientation=landscape',
    duration: '132分钟',
    year: 2019,
    rating: 9.3,
    description: '奉俊昊导演作品，一部关于社会阶层的黑色喜剧惊悚片，荣获奥斯卡最佳影片奖。',
    region: '韩国',
    views: '2150万',
    isNew: false,
    isHot: true,
    tags: ['剧情', '惊悚', '获奖'],
  },
  {
    id: 'v003',
    title: '地球脉动 第三季',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20planet%20earth%20aesthetic%2C%20stunning%20wildlife%20landscape%2C%20warm%20natural%20lighting%2C%20golden%20hour%20tones%2C%20cream%20background%2C%20professional%20wildlife%20photography%2C%20clean%20composition&width=800&height=450&seq=video-thumb-003&orientation=landscape',
    duration: '60分钟/集',
    year: 2023,
    rating: 9.8,
    description: 'BBC倾力打造的自然纪录片巅峰之作，用最先进的摄影技术捕捉地球生命的奇迹。',
    region: '英国/亚洲联合制作',
    views: '3560万',
    isNew: true,
    isHot: true,
    tags: ['自然', 'BBC', '高分'],
  },
  {
    id: 'v004',
    title: '繁花',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Shanghai%201990s%20nostalgic%20TV%20drama%20aesthetic%2C%20elegant%20modern%20Chinese%20cityscape%2C%20warm%20golden%20lighting%2C%20cream%20tones%2C%20Wong%20Kar%20wai%20style%20visual%2C%20soft%20atmosphere%2C%20clean%20composition&width=800&height=450&seq=video-thumb-004&orientation=landscape',
    duration: '45分钟/集',
    year: 2023,
    rating: 9.2,
    description: '王家卫首部电视剧，以上世纪九十年代上海为背景，讲述阿宝的传奇人生故事。',
    region: '中国大陆',
    views: '5680万',
    isNew: true,
    isHot: true,
    tags: ['剧情', '沪语', '王家卫'],
  },
  {
    id: 'v005',
    title: '你的名字',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Your%20Name%20anime%20film%20aesthetic%2C%20beautiful%20Japanese%20sky%20and%20cityscape%2C%20warm%20sunset%20tones%2C%20cream%20background%2C%20romantic%20atmosphere%2C%20Makoto%20Shinkai%20style%2C%20clean%20minimalist%20composition&width=800&height=450&seq=video-thumb-005&orientation=landscape',
    duration: '106分钟',
    year: 2016,
    rating: 9.1,
    description: '新海诚执导的动画电影，讲述两个少年男女跨越时空的身体交换与爱情故事。',
    region: '日本',
    views: '1890万',
    isNew: false,
    isHot: true,
    tags: ['动画', '爱情', '奇幻'],
  },
  {
    id: 'v006',
    title: '鱿鱼游戏',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Squid%20Game%20Korean%20drama%20aesthetic%2C%20minimalist%20geometric%20set%20design%2C%20warm%20and%20dramatic%20contrast%2C%20cream%20background%2C%20elegant%20suspense%20visual%2C%20Netflix%20series%20style%2C%20clean%20composition&width=800&height=450&seq=video-thumb-006&orientation=landscape',
    duration: '55分钟/集',
    year: 2021,
    rating: 8.9,
    description: 'Netflix韩国原创剧集，数百名负债累累的人参加致命游戏，争夺巨额奖金。',
    region: '韩国',
    views: '8920万',
    isNew: false,
    isHot: false,
    tags: ['惊悚', '悬疑', 'Netflix'],
  },
  {
    id: 'v007',
    title: '河西走廊',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Silk%20Road%20Hexi%20Corridor%20documentary%20aesthetic%2C%20ancient%20Chinese%20landscape%2C%20warm%20desert%20golden%20tones%2C%20historical%20atmosphere%2C%20cream%20background%2C%20professional%20documentary%20photography%2C%20clean%20composition&width=800&height=450&seq=video-thumb-007&orientation=landscape',
    duration: '50分钟/集',
    year: 2015,
    rating: 9.7,
    description: '央视出品的大型历史纪录片，以编年体史诗形式呈现河西走廊两千年的历史变迁。',
    region: '中国大陆',
    views: '870万',
    isNew: false,
    isHot: false,
    tags: ['历史', '中国', '文化'],
  },
  {
    id: 'v008',
    title: '燃烧',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Burning%20Korean%20film%20mystery%20aesthetic%2C%20rural%20Korean%20landscape%2C%20warm%20evening%20lighting%2C%20cream%20and%20earth%20tones%2C%20Lee%20Chang%20dong%20style%2C%20minimalist%20composition%2C%20clean%20background&width=800&height=450&seq=video-thumb-008&orientation=landscape',
    duration: '148分钟',
    year: 2018,
    rating: 8.8,
    description: '李沧东导演作品，改编自村上春树短篇小说，一部关于阶级、欲望与存在的悬疑佳作。',
    region: '韩国',
    views: '430万',
    isNew: false,
    isHot: false,
    tags: ['悬疑', '剧情', '文艺'],
  },
  {
    id: 'v009',
    title: '铃芽之旅',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Suzume%20anime%20film%20aesthetic%2C%20Japanese%20countryside%20and%20door%20motif%2C%20warm%20golden%20sunset%20lighting%2C%20cream%20background%2C%20Makoto%20Shinkai%20style%2C%20clean%20minimalist%20composition&width=800&height=450&seq=video-thumb-009&orientation=landscape',
    duration: '122分钟',
    year: 2023,
    rating: 8.7,
    description: '新海诚最新动画电影，少女铃芽踏上了关闭灾祸之门的奇幻旅程。',
    region: '日本',
    views: '1560万',
    isNew: true,
    isHot: true,
    tags: ['动画', '奇幻', '冒险'],
  },
  {
    id: 'v010',
    title: '请回答1988',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Reply%201988%20Korean%20drama%20nostalgic%20aesthetic%2C%201980s%20Korean%20neighborhood%2C%20warm%20family%20atmosphere%2C%20cream%20and%20soft%20tones%2C%20cozy%20retro%20visual%2C%20clean%20composition&width=800&height=450&seq=video-thumb-010&orientation=landscape',
    duration: '90分钟/集',
    year: 2015,
    rating: 9.7,
    description: '经典韩剧，以1988年为背景，讲述五个家庭在首尔双门洞的温情故事。',
    region: '韩国',
    views: '3250万',
    isNew: false,
    isHot: true,
    tags: ['温情', '家庭', '经典'],
  },
  {
    id: 'v011',
    title: '流浪地球2',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Wandering%20Earth%202%20Chinese%20sci%20fi%20film%20aesthetic%2C%20futuristic%20space%20station%2C%20warm%20dramatic%20lighting%2C%20cream%20background%2C%20epic%20cinematic%2C%20clean%20composition&width=800&height=450&seq=video-thumb-011&orientation=landscape',
    duration: '173分钟',
    year: 2023,
    rating: 8.5,
    description: '中国科幻大片续集，人类面临太阳危机，展开惊心动魄的太空救援行动。',
    region: '中国大陆',
    views: '4230万',
    isNew: true,
    isHot: true,
    tags: ['科幻', '灾难', '国产'],
  },
  {
    id: 'v012',
    title: '舞伎家的料理人',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Makanai%20Japanese%20drama%20aesthetic%2C%20traditional%20Kyoto%20kitchen%2C%20warm%20cozy%20lighting%2C%20cream%20and%20soft%20tones%2C%20food%20and%20culture%2C%20Hirokazu%20Koreeda%20style%2C%20clean%20composition&width=800&height=450&seq=video-thumb-012&orientation=landscape',
    duration: '40分钟/集',
    year: 2023,
    rating: 8.6,
    description: '是枝裕和执导的Netflix日剧，讲述京都舞伎宿舍中两位少女的温暖日常。',
    region: '日本',
    views: '980万',
    isNew: true,
    isHot: false,
    tags: ['温情', '美食', '日剧'],
  },
  {
    id: 'v013',
    title: '众神之地',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20wildlife%20documentary%20aesthetic%2C%20majestic%20Tibetan%20plateau%20animals%2C%20warm%20golden%20natural%20light%2C%20cream%20background%2C%20professional%20wildlife%20photography%2C%20clean%20composition&width=800&height=450&seq=video-thumb-013&orientation=landscape',
    duration: '55分钟/集',
    year: 2022,
    rating: 9.5,
    description: 'B站出品的高分自然纪录片，探寻中国境内四种旗舰动物的神秘世界。',
    region: '中国大陆',
    views: '620万',
    isNew: false,
    isHot: false,
    tags: ['自然', '中国', '野生动物'],
  },
  {
    id: 'v014',
    title: '调音师',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Andhadhun%20Indian%20thriller%20film%20aesthetic%2C%20piano%20and%20mystery%2C%20warm%20dramatic%20lighting%2C%20cream%20and%20dark%20contrast%2C%20Bollywood%20cinematic%2C%20clean%20composition&width=800&height=450&seq=video-thumb-014&orientation=landscape',
    duration: '139分钟',
    year: 2018,
    rating: 8.6,
    description: '印度黑色喜剧惊悚片，假装盲人的钢琴师意外卷入一场谋杀案中。',
    region: '印度',
    views: '1150万',
    isNew: false,
    isHot: false,
    tags: ['悬疑', '喜剧', '印度'],
  },
  {
    id: 'v015',
    title: '鬼灭之刃 无限列车篇',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20anime%20film%20aesthetic%2C%20Japanese%20train%20and%20flame%20motif%2C%20warm%20dramatic%20lighting%2C%20cream%20background%2C%20dynamic%20action%20composition%2C%20clean%20style&width=800&height=450&seq=video-thumb-015&orientation=landscape',
    duration: '117分钟',
    year: 2020,
    rating: 8.8,
    description: '现象级动画电影，炭治郎一行登上无限列车，与炎柱炼狱杏寿郎并肩作战。',
    region: '日本',
    views: '5670万',
    isNew: false,
    isHot: true,
    tags: ['动画', '热血', '战斗'],
  },
  {
    id: 'v016',
    title: '夏日重现',
    category: 'duanpian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Summer%20Time%20Rendering%20anime%20short%20film%20aesthetic%2C%20Japanese%20island%20summer%20atmosphere%2C%20warm%20sunset%20beach%20lighting%2C%20cream%20background%2C%20mystery%20visual%2C%20clean%20composition&width=800&height=450&seq=video-thumb-016&orientation=landscape',
    duration: '25分钟/集',
    year: 2022,
    rating: 8.9,
    description: '原创动画短片集，以夏日海岛为舞台的悬疑科幻故事，画风精美绝伦。',
    region: '日本',
    views: '780万',
    isNew: true,
    isHot: false,
    tags: ['动画', '悬疑', '科幻'],
  },
  {
    id: 'v017',
    title: '风味人间 第四季',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Once%20Upon%20a%20Bite%20food%20documentary%20aesthetic%2C%20Asian%20cuisine%20preparation%2C%20warm%20kitchen%20lighting%2C%20cream%20background%2C%20gourmet%20food%20photography%2C%20clean%20composition&width=800&height=450&seq=video-thumb-017&orientation=landscape',
    duration: '50分钟/集',
    year: 2023,
    rating: 9.3,
    description: '陈晓卿执导的美食纪录片，以全球视野探寻谷物与人类文明的深厚联结。',
    region: '中国大陆',
    views: '2340万',
    isNew: true,
    isHot: true,
    tags: ['美食', '文化', '纪录片'],
  },
  {
    id: 'v018',
    title: '新世界',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=New%20World%20Korean%20gangster%20film%20aesthetic%2C%20dark%20elegant%20corporate%20setting%2C%20warm%20dramatic%20contrast%2C%20cream%20background%2C%20crime%20thriller%20visual%2C%20clean%20composition&width=800&height=450&seq=video-thumb-018&orientation=landscape',
    duration: '134分钟',
    year: 2013,
    rating: 8.9,
    description: '韩国黑帮史诗巨作，卧底警察在黑帮世界中逐渐迷失自我的故事。',
    region: '韩国',
    views: '890万',
    isNew: false,
    isHot: false,
    tags: ['黑帮', '犯罪', '剧情'],
  },
  {
    id: 'v019',
    title: '长安三万里',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chang%20An%20Chinese%20animation%20film%20aesthetic%2C%20Tang%20dynasty%20ancient%20city%2C%20warm%20golden%20historical%20lighting%2C%20cream%20background%2C%20poetic%20visual%2C%20clean%20composition&width=800&height=450&seq=video-thumb-019&orientation=landscape',
    duration: '168分钟',
    year: 2023,
    rating: 8.7,
    description: '追光动画打造的历史动画巨制，以盛唐为背景讲述李白与高适的人生故事。',
    region: '中国大陆',
    views: '3210万',
    isNew: true,
    isHot: true,
    tags: ['动画', '历史', '国产'],
  },
  {
    id: 'v020',
    title: '奔跑吧 第十一季',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Running%20Man%20Chinese%20variety%20show%20aesthetic%2C%20bright%20outdoor%20game%20setting%2C%20warm%20sunny%20lighting%2C%20cream%20background%2C%20entertaining%20visual%2C%20clean%20composition&width=800&height=450&seq=video-thumb-020&orientation=landscape',
    duration: '90分钟/集',
    year: 2023,
    rating: 8.3,
    description: '浙江卫视王牌综艺节目，明星嘉宾在各地展开趣味竞技挑战。',
    region: '中国大陆',
    views: '4560万',
    isNew: true,
    isHot: true,
    tags: ['综艺', '竞技', '娱乐'],
  },
];